import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { Callout, Typography } from 'seagull';
import { CreateProposalButton } from '~/components/CreateProposalButton/CreateProposalButton';
import { useLocaleKeys } from '~/i18n';
import styles from './AdHocAgreementEmptyState.module.scss';
export const AdHocAgreementEmptyStateTestIds = pathgen('adhoc-agreement-empty-state');
export const AdHocAgreementEmptyState = (param)=>{
    let { clientContactId } = param;
    const { t } = useLocaleKeys('pages.globalBillingHubAdHocAgreementEmptyState');
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AdHocAgreementEmptyStateTestIds.Root(),
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.emptyStateCard,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        testId: "adhoc-agreement-empty-title",
                        children: t.title()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        color: "secondary",
                        testId: "adhoc-agreement-empty-message",
                        children: t.message()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Callout, {
                testId: AdHocAgreementEmptyStateTestIds.CreateProposalCallout(),
                withAction: /*#__PURE__*/ _jsx(CreateProposalButton, {
                    text: t.createProposal(),
                    navigationState: clientContactId != null ? {
                        clientContactId
                    } : undefined
                }),
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: t.createProposalPrompt()
                })
            })
        ]
    });
};
